//
// Single point of contact for Vue
//
import Vue from 'vue';
import { mergeData } from 'vue-functional-data-merge';
export default Vue;
export { mergeData };